import React, { Fragment } from "react";
import { Link } from "react-router-dom";

const ServiceContent = [
  {
    icon: "icon_24",
    title: "Product Development",
    desc: `Data analytics offers both estimation and exploration capability for information. It allows one to understand the market or process’s current state and offers a solid base for forecasting future results. Data analysis helps companies to comprehend the current business situation and change the processor cause the need for a new product creation that meets market requirements.`,
    // arrow: "bi bi-arrow-right",
    fade: "fade-up",
    dataDelay: "",
  },
  {
    icon: "icon_25",
    title: "Target Content",
    desc: `Learning what consumers wish in advance improves consumer orientation in marketing campaigns. It encourages advertisers to tailor their advertising to a subset of the entire consumer base. It also allows you to figure out which client base group can better respond to the initiative. It also saves money to convince a buyer to buy and increases the overall performance of the marketing activities.`,
    // arrow: "bi bi-arrow-right",
    fade: "fade-up",
    dataDelay: "100",
  },
  {
    icon: "icon_26",
    title: "Efficiency in Operations",
    desc: `The importance of data analytics in marketing finds more viable ways to streamline operations or increase benefit levels. It helps to recognize possible issues, avoids the waiting period, and takes action on them. `,
    // arrow: "bi bi-arrow-right",
    fade: "fade-up",
    dataDelay: "200",
  },
  {
    icon: "icon_27",
    title: "Data Analysis",
    desc: `Convert data nois intelligent insights for quis competitive differentiation.`,
    // arrow: "bi bi-arrow-right",
    fade: "fade-up",
    dataDelay: "300",
  },
];

const FancyFeatureThirteen = () => {
  return (
    <Fragment>
      <div className="row">
        {ServiceContent.map((val, i) => (
          <div
            key={i}
            className="col-xl-3 col-sm-6 d-flex"
            data-aos={val.fade}
            data-aos-delay={val.dataDelay}
          >
            <div className="block-style-ten tran3s mt-30">
              <div className="icon d-flex align-items-end">
                <img src={`images/icon/${val.icon}.svg`} alt="" />
              </div>
              {/* <h6>
                <Link to="/service-details">{val.title}</Link>
              </h6> */}
              <p>{val.desc}</p>
              <Link to="/service-details" className="read-btn tran3s">
                <i className={val.arrow} />
              </Link>
            </div>
            {/* /.block-style-ten */}
          </div>
        ))}
      </div>
    </Fragment>
  );
};

export default FancyFeatureThirteen;
